import { ArrowLeft } from "lucide-react";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useRegionStore } from "../../store/store";

const UpdateRegion: React.FC = () => {
  const { id } = useParams<{ id: any }>();
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname.split("/");
  const isView = path[2] === "view-region" ? true : false;

  const [regionData, setRegionData] = useState({
    regionName: "",
    regionCode: "",
  });
  const [errors, setErrors] = useState({ regionName: "", regionCode: "" });

  const { updateRegionById, createRegion, getRegionById } = useRegionStore();

  useEffect(() => {
    const fetchRegion = async () => {
      if (id) {
        try {
          const data = await getRegionById(id);
          setRegionData({
            regionName: data?.regionName,
            regionCode: data?.regionCode,
          });
        } catch (error) {
          console.error("Error fetching region:", error);
        }
      }
    };

    fetchRegion();
  }, [id]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRegionData({ ...regionData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateErrors = () => {
    let valid = true;
    const newErrors = { regionName: "", regionCode: "" };

    if (!regionData.regionName.trim()) {
      newErrors.regionName = "Region Name is required";
      valid = false;
    }
    if (!regionData.regionCode.trim()) {
      newErrors.regionCode = "Region Code is required";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateErrors()) {
      return;
    }

    const payload = { ...regionData };

    if (id) {
      await updateRegionById(id, payload).then(() => {
        navigate("/regions");
        return;
      });
    }

    if (!id) {
      await createRegion(payload).then(() => {
        navigate("/regions");
        return;
      });
    }
  };

  return (
    <>
      <div className="flex w-full mt-16 flex-col mb-2 mt-16 flex-col justify-start  px-3 items-start">
        <div className="w-full h-full flex justify-between items-center  mr-4  pb-2  ">
          <h2>
            {isView === true
              ? "View Region"
              : id
              ? "Update Region"
              : "Add Region"}
          </h2>

          <Link to="/regions" data-discover="true">
            <button className="flex items-center px-3 py-2 bg-[#61748e] text-white rounded-full">
              <ArrowLeft />
              Back
            </button>
          </Link>
        </div>

        <div className="w-full h-full drop-shadow-lg mr-4 rounded-t-lg bg-white flex-col">
          <form className="w-full px-4 py-4 h-[350px] ">
            <div className="grid grid-rows-2 grid-cols-2 w-full leading-none gap-y-8 gap-x-3 ">
              <div className="flex flex-col ">
                <label className="text-lg font-semibold">Region Name</label>
                <input
                  type="text"
                  className={`py-2 border-2 border-gray-400 rounded-md ml-1 px-1 ${
                    isView ? "bg-gray-100" : ""
                  }`}
                  placeholder="Region Name"
                  name="regionName"
                  readOnly={isView === true}
                  value={regionData.regionName}
                  onChange={handleChange}
                />
                {errors.regionName && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.regionName}
                  </p>
                )}
              </div>
              <div className="flex flex-col">
                <label className="text-lg font-semibold">Region Code</label>
                <input
                  type="text"
                  className={`py-2 border-2 border-gray-400 rounded-md ml-1 px-1 ${
                    isView ? "bg-gray-100" : ""
                  }`}
                  placeholder="Region Code"
                  name="regionCode"
                  readOnly={isView === true}
                  value={regionData.regionCode}
                  onChange={handleChange}
                />
                {errors.regionCode && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.regionCode}
                  </p>
                )}
              </div>
            </div>
          </form>
          <div className="w-full mt-7 flex justify-end items-center h-18 p-2 bg-[#61748e]">
            <>
              {isView ? (
                ""
              ) : (
                <button
                  onClick={(e) => handleSubmit(e)}
                  type="submit"
                  className="h-10 bg-[#0fa9a6] text-white text-lg px-5 py-1 rounded-full bottom-0 left-0 right-0"
                >
                  {id ? "Update" : "Add"}
                </button>
              )}
            </>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateRegion;
